import { Data } from '@angular/router/src/config';
import { DTOBase } from './Dtobase';

export class Invoice extends DTOBase {
    InvoiceID: number;
    CustomerID: string;
    Status: number;
    TotalInvoiceAmount: number;
    PaidAmount: number;
    PaymentMode: number;
    SalesDate: Date;
    ShipDate: Date;
    DueDate: Date;
    TotalTax: number;
    IsShipped: boolean;
    TotalProductsAmount: number;
    PaidDate: Date;
    InvoiceDiscount: number;
    CreatedOn: Date;
    InvoiceNumber: number;
    KIDNumber: string;
    ReferenceInvoiceID: string;
    ProductPriceList: string;
}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/common/models/invoice.ts